import { DomainIDs } from 'common/constants/enums';

import { GlobalState } from '../store/initialState';

export const getIsVisisble = (state: GlobalState): boolean =>
  state[DomainIDs.SLEEP_DIARY_MODAL].isVisible;
